/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Kinesiotaping_TermsInputs */

const en_service_type_kinesiotaping_terms = /** @type {(inputs: Service_Type_Kinesiotaping_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kinesio taping, taping, kt tape, sports tape`)
};

const pl_service_type_kinesiotaping_terms = /** @type {(inputs: Service_Type_Kinesiotaping_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kinesiotaping, kinezjotaping, taping, plastrowanie, tejpy, plastry`)
};

/**
* | output |
* | --- |
* | "kinesio taping, taping, kt tape, sports tape" |
*
* @param {Service_Type_Kinesiotaping_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_kinesiotaping_terms = /** @type {((inputs?: Service_Type_Kinesiotaping_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Kinesiotaping_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_kinesiotaping_terms(inputs)
	return en_service_type_kinesiotaping_terms(inputs)
});